import {getUrlParams, goTo} from '@/utils';
import React from 'react';
import globalStore from '@services/global.state';
import {HomeGameCardItem} from '@/pages/home/home.type';
import BaseImageCard from './base-image-card';

const ColorCard = ({
  v,
}: {
  i: number;
  v: HomeGameCardItem;
  serverTime?: number;
  currentTime?: number;
}) => {
  return (
    <BaseImageCard
      imageUrl={v.otherUrl || v.gamePic}
      onClick={() => {
        globalStore.updateAmount.next({gameType: 'Color'});
        const params = getUrlParams(v.gameUrl);
        const cycle = v.clcyle || Number(params.cycle || 0);
        if (cycle) {
          params.cycle = `${cycle}`;
        }
        goTo('Color', params);
      }}
    />
  );
};

export default ColorCard;
